/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, AuditReportsGetGipAltReportEvidenceExportUrlPathParams, AuditReportsGetGipAltReportEvidenceExportUrl401, AuditReportsGetGipAltReportEvidenceExportUrl403, AuditReportsGetGipAltReportEvidenceExportUrl404 } from "../models/AuditReportsGetGipAltReportEvidenceExportUrl";

export function getAuditReportsGetGipAltReportEvidenceExportUrlUrl(id: AuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip-alt/report/${id}/evidence-export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/evidence-export-url}
 */
export async function auditReportsGetGipAltReportEvidenceExportUrl(id: AuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportEvidenceExportUrl401 | AuditReportsGetGipAltReportEvidenceExportUrl403 | AuditReportsGetGipAltReportEvidenceExportUrl404>, unknown>({ method : "GET", url : getAuditReportsGetGipAltReportEvidenceExportUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}